import store from '@/store'
import router from '@/router'
import { getUid, getParams } from '@/api/public'
import _ from 'lodash'
import { getObjFromUrl } from '@/utils'
export function handleUrlIdQuery(query) {
	// 全局参数字段
	const globalParams = [
		'brand_id',
		'cat_id',
		'cats',
		'plat',
		'item_id',
		'sku_id',
		'content_word',
		'shop_id',
		'custom_filters',
		'item_analyse',
		'attr_filters',
		'price_min',
		'price_max',
		'title_word',
		'url_id',
		'parent_cat_id',
		'fx_url_id',
	]
	const {
		brand,
		cid,
		plat,
		item_id,
		sku,
		content_word,
		price_min,
		price_max,
		shop,
		fx_url_id,
	} = query
	let urlIdParams = {}
	let otherParams = {}
	for (const key in query) {
		if (query.hasOwnProperty(key)) {
			// 检查键是否是'plat'或'cid'
			if (
				[
					'brand',
					'cid',
					'plat',
					'item_id',
					'sku',
					'content_word',
					'price_min',
					'price_max',
					'shop',
					'fx_url_id',
				].includes(key)
			) {
				switch (key) {
					case 'brand':
						urlIdParams['brand_id'] = query[key]
						break
					case 'cid':
						urlIdParams['cat_id'] = query[key]
						break
					case 'shop':
						urlIdParams['shop_id'] = query[key]
						break
					case 'sku':
						urlIdParams['sku_id'] = query[key]
						break
					default:
						urlIdParams[key] = query[key]
				}
			} else {
				otherParams[key] = query[key]
			}
		}
	}
	return {
		urlParams: urlIdParams,
		otherParams: otherParams,
	}
}

export function changeUrlId(filterParams, param, value) {
	let params = filterParams ? filterParams : {}
	if (!filterParams && param) {
		params = store.state.user.filterParams
			? _.cloneDeep(store.state.user.filterParams)
			: {}
		if (typeof param == 'string') {
			params[param] = value
		} else {
			param.forEach((item, index) => {
				params[item] = value[index]
			})
		}
	}
	if (typeof params.custom_filters !== 'string') {
		params.custom_filters = JSON.stringify(params.custom_filters)
	}
	if (window.mixpanel && !store.state.user.isTriggerSearchChange) {
		let query = getObjFromUrl(window.location.hash)
		let newParams = Object.assign(
			{
				monthType: sessionStorage.getItem('tsType')
					? sessionStorage.getItem('tsType')
					: 'month',
				start: query.start,
				end: query.end,
			},
			params
		)
		window.mixpanel.track('Search Change', newParams)
	}
	store.dispatch('user/changeIsTriggerSearchChange', false)
	return new Promise((resolve) => {
		getUid(params).then((res) => {
			if (res.status == 'ok') {
				const result = res.result
				store.dispatch('user/changeUrlId', result).then(() => {
					store
						.dispatch('user/changeFilterParams', params)
						.then(() => {
							resolve(result)
							return
						})
				})
			}
		})
	})
}

export function computeCustomFilter(param_val) {
	/* {words, aspect_type, label_level, analyse_type, rule_id, ner_type, asp_level}*/
	if (param_val.words) {
		let customFilters = []
		param_val.words.split(',').forEach((item, index) => {
			let filterObj = {}
			filterObj.analyse_typ = param_val.analyse_typ
				? param_val.analyse_typ.split(',')[index]
				: ''
			if (filterObj.analyse_typ == '') {
				// 方面/观点 && nertabs
				if (
					param_val.label_level.toString().split(',')[index] == 1 &&
					param_val.ner_type.split(',')[index] == '' &&
					param_val.rule_id.split(',')[index] == ''
				) {
					filterObj.words = decodeURIComponent(item.split('_')[0])
					filterObj.opinions = decodeURIComponent(item.split('_')[1])
				} else if (
					item.includes('~') &&
					param_val.rule_id.split(',')[index] !== ''
				) {
					filterObj.words = decodeURIComponent(
						item.replaceAll('~', ',')
					)
				} else {
					filterObj.words = decodeURIComponent(item)
				}
			} else {
				// 人群分析/场景分析
				filterObj.words = decodeURIComponent(item)
			}
			filterObj.rule_id = param_val.rule_id
				? param_val.rule_id.split(',')[index]
				: ''

			filterObj.label_level = param_val.label_level
				? param_val.label_level.toString().split(',')[index]
				: ''
			filterObj.ner_type = param_val.ner_type
				? param_val.ner_type.split(',')[index]
				: ''
			filterObj.aspect_type = param_val.aspect_type
				? param_val.aspect_type.split(',')[index]
				: ''
			if (
				param_val.asp_level &&
				param_val.asp_level.split(',')[index] !== 'level0'
			) {
				filterObj.asp_level = param_val.asp_level.split(',')[index]
			}
			customFilters.push(filterObj)
		})
		store.dispatch('user/changeCustomFilters', customFilters)
		return JSON.stringify(customFilters)
	} else {
		store.dispatch('user/changeCustomFilters', '')
		return ''
	}
}

export function computeAttrFilter(param_val) {
	// attr_name attr_id
	if (param_val.attr_name) {
		let attrFilters = []
		param_val.attr_name.split(',').forEach((item, index) => {
			let filterObj = {}
			filterObj.attr = param_val.attr_name
				? param_val.attr_name.split(',')[index]
				: ''
			filterObj.value = param_val.attr_id
				? param_val.attr_id.split(',')[index]
				: ''
			attrFilters.push(filterObj)
		})
		store.dispatch('user/changeAttrFilters', attrFilters)
		return attrFilters
	} else {
		store.dispatch('user/changeAttrFilters', '')
		return ''
	}
}
